function Divider() {
  return <div className="h-0 my-3 border-bottom border-1" />;
}

export default Divider;
